import type { Ref } from 'vue';

export interface ReadonlyRef<T> extends Ref<T> {
  readonly value: T;
}

export type ToReadonlyRef<T extends Ref<unknown>> =
  T extends Ref<infer K> ? ReadonlyRef<K> : never;

export function readonlyRef<T>(value: Ref<T>): ToReadonlyRef<Ref<T>> {
  return value;
}
